import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from "react-router-dom";
import '../../App.css'; // Assuming CSS is in this file

const BACKEND_ORIGIN = process.env.REACT_APP_BACKEND_ORIGIN;

function setVisibility(v) {
  document.getElementById('vis-public').classList.toggle('active', v === 'public');
  document.getElementById('vis-friends').classList.toggle('active', v === 'friends');
}

const GameRoom = () => {
  const [activeTab, setActiveTab] = useState("chat");
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [errorFetch, setErrorFetch] = useState(false);
  const [live, setLive] = useState(true);
  useEffect(() => {
    async function getGame() {
      try {
        const res = await fetch(`${BACKEND_ORIGIN}/game`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: `{"gameID": "${id}"}`
        });
        if (!res.ok) {
          throw new Error(`Fetch error (not ok): ${res.status}`)
        }
        const jsonData= await res.json();
        setData(jsonData);
        setErrorFetch(false);
        console.log("Live updated!");
      }
      catch(err) {
        setErrorFetch(true);
      }
      finally {
        setLoading(false);
      }
    }
    getGame();
    const interval = setInterval(getGame, 1000 * 10);
    if (!live) {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [live]);
  if (!id) {
    return (
      <div id="game" className="page-active">
        No game selected!
      </div>
    );
  }
  if (loading) {
    return (
      <div>
        Loading...
      </div>
    );
  }
  if (errorFetch) {
    return (
      <div>Error loading game. Is the game ID correct?</div>
    )
  }
  const game = data["contests"][0];
  //console.log(game);
  /*
  if (game["gameState"] == "P") {
    return (
      <div>Game has not started yet!</div>
    );
  }
  */
  const switchGameTab = (tab) => {
    ['chat','reviews','stats'].forEach(t => {
    var tabEl = document.getElementById('tab-' + t);
    setActiveTab(tab);
    if (tabEl) tabEl.classList.toggle('active', t === tab)});
  };
  return (
    <div id="game" className="page-active">
      <div className="page-header">
        <div className="page-title">{game["teams"]["1"]["nameShort"]} vs {game["teams"]["0"]["nameShort"]}</div>
        <div className="live-indicator"><div className="pulse-dot"></div>LIVE</div>
      </div>

      <div className="big-scoreboard">
        <div className="big-score-row">
          <div className="big-team">
            <div className="big-logo" style={{background: 'rgba(29,77,120,0.25)', color: '#1d6fa8', border: '2px solid rgba(29,77,120,0.4)', fontFamily:'var(--font-head)', fontSize:'18px', fontWeight:'900'}}>{game["teams"]["1"]["name6Char"]}</div>
            <div>
              <div className="big-team-name">{game["teams"]["1"]["nameShort"]}</div>
              <div style={{fontSize:'12px', color:'var(--fd-muted)'}}>{game["teams"]["1"]["record"]}</div>
            </div>
          </div>
          <div className="big-score">
            <div className="big-score-nums">{game["teams"]["1"]["score"]} · {game["teams"]["0"]["score"]}</div>
            <div className="big-score-period">● {game["currentPeriod"]} · {game["clock"]}</div>
          </div>
          <div className="big-team right">
            <div className="big-logo" style={{background: 'rgba(149,71,12,0.2)', color: '#c97a2a', border: '2px solid rgba(149,71,12,0.35)', fontFamily:'var(--font-head)', fontSize:'18px', fontWeight:'900'}}>{game["teams"]["0"]["name6Char"]}</div>
            <div style={{textAlign:'right'}}>
              <div className="big-team-name">{game["teams"]["0"]["nameShort"]}</div>
              <div style={{fontSize:'12px', color:'var(--fd-muted)'}}>{game["teams"]["0"]["record"]}</div>
            </div>
          </div>
        </div>
      </div>
      {/*
      <div className="odds-bar">
          <div style={{fontSize:'11px', fontWeight:'700', textTransform:'uppercase', letterSpacing:'1px', color:'var(--fd-muted)'}}>ESPN BET</div>
          <div className="odd-item">Spread:<span>OKC -6.5</span></div>
          <div className="odd-item">ML:<span>OKC -240</span></div>
          <div className="odd-item">O/U:<span>228.5</span></div>
          <div className="odd-item">OKC win%:<span style={{color:'var(--fd-green-light)'}}>71%</span></div>
      </div>
      */}
      <div className="tabs">
        <div className="tab active" id="tab-chat" onClick={() => switchGameTab('chat')}>💬 Live Chat</div>
        <div className="tab" id="tab-reviews" onClick={() => switchGameTab('reviews')}>⭐ Reviews</div>
        <div className="tab" id="tab-stats" onClick={() => switchGameTab('stats')}>📊 Box Score</div>
      </div>
      { activeTab === 'chat' && <LiveChat/> }
      { activeTab === 'reviews' && <Reviews gameData={game}/>}
      { activeTab === 'stats' && <BoxScore/>}
    </div>
  );
};

const UNDER_CONSTRUCTION = true;

// TODO: Disable live chat tab in Game Room page for finished games
const LiveChat = () => {
  if (UNDER_CONSTRUCTION) return (<div>UNDER CONSTRUCTION</div>);
  return (
    <div id="game-tab-chat">
      <div style={{padding: '12px 16px', borderBottom: '1px solid var(--fd-border)'}}>
      <div className="chat-input-area">
        <textarea className="chat-input" placeholder="React live..." rows="1"></textarea>
        <button className="send-btn"><i className="ti ti-send" aria-hidden="true"></i></button>
      </div>
      </div>
      <div style={{padding: '12px 16px', overflowY: 'auto', maxHeight: '380px'}}>
      <div className="chat-message">
        <div className="msg-avatar verified" style={{background: 'linear-gradient(135deg, #1a7a4a, #0f4d2d)'}}>SJ</div>
        <div className="msg-body">
        <div className="msg-header">
          <span className="msg-name">SportsJunkie_23</span>
          <span className="fan-badge">Fan</span>
          <span className="msg-time">4:24</span>
        </div>
        <div className="msg-text">SGA is LOCKED IN tonight. 31 pts and it's only the 3rd 🔥</div>
        <div className="foam-row">
          <button className="foam-btn active"><span className="foam-icon">🤙</span> 234</button>
          <button className="foam-btn"><i className="ti ti-corner-up-right" style={{fontSize:'13px'}} aria-hidden="true"></i> Reply</button>
        </div>
        </div>
      </div>

      <div className="chat-message">
        <div className="msg-avatar" style={{background: 'linear-gradient(135deg, #6b2a8a, #421560)'}}>MV</div>
        <div className="msg-body">
        <div className="msg-header">
          <span className="msg-name">MaverickVoice</span>
          <span className="msg-time">4:19</span>
        </div>
        <div className="msg-text">Jokic is cooked without Murray. That ankle clearly still bothering him 👀</div>
        <div className="foam-row">
          <button className="foam-btn"><span className="foam-icon">🤙</span> 89</button>
          <button className="foam-btn"><i className="ti ti-corner-up-right" style={{fontSize:'13px'}} aria-hidden="true"></i> Reply</button>
        </div>
        </div>
      </div>

      <div className="chat-message">
        <div className="msg-avatar verified" style={{background: 'linear-gradient(135deg, #2a6496, #1a3d5c)'}}>HH</div>
        <div className="msg-body">
        <div className="msg-header">
          <span className="msg-name">HoopsHead</span>
          <span className="fan-badge">Top Fan</span>
          <span className="msg-time">4:12</span>
        </div>
        <div className="msg-text">That Holmgren block was INSANE. Top 5 plays of the playoffs easily</div>
        <div className="foam-row">
          <button className="foam-btn active"><span className="foam-icon">🤙</span> 412</button>
          <button className="foam-btn"><i className="ti ti-corner-up-right" style={{fontSize:'13px'}} aria-hidden="true"></i> Reply</button>
        </div>
        </div>
      </div>

      <div className="chat-message">
        <div className="msg-avatar" style={{background: 'linear-gradient(135deg, #8a3a2a, #5c1f10)'}}>DK</div>
        <div className="msg-body">
        <div className="msg-header">
          <span className="msg-name">DenverKid</span>
          <span className="msg-time">4:08</span>
        </div>
        <div className="msg-text">This ref crew is absolutely shameful. 3 touch fouls on Jokic in 4 minutes. The league is rigged lmao</div>
        <div className="foam-row">
          <button className="foam-btn"><span className="foam-icon">🤙</span> 56</button>
          <button className="foam-btn"><i className="ti ti-corner-up-right" style={{fontSize:'13px'}} aria-hidden="true"></i> Reply</button>
        </div>
        </div>
      </div>
      </div>
    </div>
  );
};

// TODO: Replace alerts with proper in-site messages and (maybe?) disable posting reviews in games that already have a review from the user.
// Add constraints, like review must be non-empty (optional)
const Reviews = ({gameData}) => {
  const [review, setReview] = useState("");
  const [stars, setStars] = useState(1);
  const [publicReview, setPublicReview] = useState(true);
  const { id } = useParams();
  const user = JSON.parse(localStorage.getItem("user"));
  const handleStarsChange = async (event) => {
    const selectedStars = Number(event.target.dataset.v);
    setStars(selectedStars);
  }
  const handleReviewChange = async (event) => {
    setReview(event.target.value)
  }
  const handlePublicChange = async (event) => {
    setPublicReview(event.target.dataset.v === "true");
  }
  const handleReviewSubmit = async () => {
    const response = await fetch(`${BACKEND_ORIGIN}/writereview`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        userID: user.uuid,
        gameID: id,
        stars: stars,
        review: review,
        public: publicReview,
        away: gameData["teams"]["1"]["name6Char"],
        home: gameData["teams"]["0"]["name6Char"],
        awayScore: gameData["teams"]["1"]["score"],
        homeScore: gameData["teams"]["0"]["score"],
        awayLong: gameData["teams"]["1"]["nameShort"],
        homeLong: gameData["teams"]["0"]["nameShort"],
        gameDate: new Date(Number(gameData["startTimeEpoch"]) * 1000)
      })
    });
    if (response.ok) {
      alert("Review submitted!");
    }
    else {
      alert("Error saving review: " + response.message);
    }
  }
  return (
    <div id="game-tab-reviews">
      <div className="review-form-card">
        <div className="review-form-title">Write a Review</div>
        <div className="star-select" id="star-select">
          <span className={`star-pick ${stars >= 1 ? "on" : ""}`} data-v="1" onClick={handleStarsChange}>★</span>
          <span className={`star-pick ${stars >= 2 ? "on" : ""}`} data-v="2" onClick={handleStarsChange}>★</span>
          <span className={`star-pick ${stars >= 3 ? "on" : ""}`} data-v="3" onClick={handleStarsChange}>★</span>
          <span className={`star-pick ${stars >= 4 ? "on" : ""}`} data-v="4" onClick={handleStarsChange}>★</span>
          <span className={`star-pick ${stars >= 5 ? "on" : ""}`} data-v="5" onClick={handleStarsChange}>★</span>
        </div>
        <textarea className="review-textarea" placeholder="Share your take on this game..." value={review} onChange={handleReviewChange}></textarea>
        <div className="review-form-footer">
          <div className="visibility-toggle">
          <div className={`vis-opt ${publicReview ? "active" : ""}`} id="vis-public" data-v="true" onClick={handlePublicChange}>Public</div>
          <div className={`vis-opt ${!publicReview ? "active" : ""}`} id="vis-friends" data-v="false" onClick={handlePublicChange}>Friends</div>
          </div>
          <button className="btn-primary" style={{padding:'7px 16px', fontSize:'12px'}} onClick={handleReviewSubmit}>Post Review</button>
        </div>
        </div>

        <div style={{padding: '0 24px', overflowY: 'auto', maxHeight: '300px'}}>
        <div className="review-card">
          <div className="review-header">
            <div className="msg-avatar" style={{background: 'linear-gradient(135deg, #6b2a8a, #421560)', width:'32px', height:'32px', fontSize:'12px'}}>PM</div>
            <div>
              <div style={{fontSize:'13px', fontWeight:'600'}}>ProspectMike</div>
              <div style={{fontSize:'11px', color:'var(--fd-muted)'}}>OKC fan · Watching live</div>
            </div>
            <div className="stars">
                <span className="star">★</span><span className="star">★</span><span className="star">★</span><span className="star">★</span><span className="star">★</span>
            </div>
          </div>
          <div className="review-text">SGA is making a case for MVP with this performance. The way OKC plays team basketball — it's refreshing compared to the iso-heavy league. Holmgren is a generational talent.</div>
          <div className="review-footer">
            <div className="foam-btn"><span className="foam-icon">🤙</span> 63</div>
            <div className="visibility-badge friends">Friends</div>
          </div>
        </div>
        </div>
    </div>
  );
};

// TODO: Implement game-specific box score from API
const BoxScore = () => {
  if (UNDER_CONSTRUCTION) return (<div>UNDER CONSTRUCTION</div>);
  return (
    <div id="game-tab-stats" style={{padding: '16px 24px'}}>
      <div style={{display:'grid', gridTemplateColumns: '1fr 1fr', gap:'12px'}}>
        <div>
          <div style={{fontFamily:'var(--font-head)', fontSize:'13px', fontWeight:'800', letterSpacing:'1px', textTransform:'uppercase', marginBottom:'8px', color:'var(--fd-muted)'}}>OKC Thunder · 87</div>
          <div style={{fontSize:'12px', color:'var(--fd-muted)', display:'grid', gridTemplateColumns: '1fr auto auto auto', gap:'4px 10px', alignItems:'center'}}>
          <span style={{fontWeight:'700', fontSize:'13px', color:'var(--fd-text)'}}>Player</span><span>PTS</span><span>REB</span><span>AST</span>
          <span style={{color:'var(--fd-text)', fontWeight:'600'}}>Gilgeous-Alex.</span><span style={{color:'var(--fd-gold)', fontWeight:'700'}}>31</span><span>5</span><span>8</span>
          <span style={{color:'var(--fd-text)'}}>Holmgren</span><span>14</span><span>9</span><span>2</span>
          <span style={{color:'var(--fd-text)'}}>Williams</span><span>12</span><span>4</span><span>6</span>
          <span style={{color:'var(--fd-text)'}}>Dort</span><span>11</span><span>3</span><span>2</span>
          <span style={{color:'var(--fd-text)'}}>Caruso</span><span>8</span><span>2</span><span>5</span>
          </div>
        </div>
        <div>
          <div style={{fontFamily:'var(--font-head)', fontSize:'13px', fontWeight:'800', letterSpacing:'1px', textTransform:'uppercase', marginBottom:'8px', color:'var(--fd-muted)'}}>DEN Nuggets · 79</div>
          <div style={{fontSize:'12px', color:'var(--fd-muted)', display:'grid', gridTemplateColumns: '1fr auto auto auto', gap:'4px 10px', alignItems:'center'}}>
          <span style={{fontWeight:'700', fontSize:'13px', color:'var(--fd-text)'}}>Player</span><span>PTS</span><span>REB</span><span>AST</span>
          <span style={{color:'var(--fd-text)', fontWeight:'600'}}>Jokic</span><span style={{color:'var(--fd-gold)', fontWeight:'700'}}>24</span><span>14</span><span>7</span>
          <span style={{color:'var(--fd-text)'}}>Porter Jr.</span><span>15</span><span>6</span><span>1</span>
          <span style={{color:'var(--fd-text)'}}>Gordon</span><span>13</span><span>5</span><span>2</span>
          <span style={{color:'var(--fd-text)'}}>Braun</span><span>12</span><span>3</span><span>4</span>
          <span style={{color:'var(--fd-text)'}}>Caldwell-Pope</span><span>8</span><span>2</span><span>3</span>
          </div>
        </div>
        </div>
        <div style={{marginTop:'16px', display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px'}}>
        <div>
            <div style={{fontSize:'11px', textTransform:'uppercase', letterSpacing:'1px', color:'var(--fd-muted)', marginBottom:'6px'}}>Team Stats</div>
            <div style={{fontSize:'12px', color:'var(--fd-muted)', display:'grid', gridTemplateColumns: '1fr auto auto', gap:'3px 12px'}}>
            <span></span><span style={{color:'var(--fd-text)'}}>OKC</span><span style={{color:'var(--fd-text)'}}>DEN</span>
            <span>FG%</span><span style={{color:'var(--fd-green-light)'}}>51.2%</span><span>44.8%</span>
            <span>3PT%</span><span style={{color:'var(--fd-green-light)'}}>38.5%</span><span>32.1%</span>
            <span>REB</span><span style={{color:'var(--fd-gold)'}}>39</span><span>41</span>
            <span>TO</span><span style={{color:'var(--fd-red)'}}>11</span><span>8</span>
            </div>
        </div>
      </div>
    </div>

  );
};

export default GameRoom;
